// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { defaultShippingAddressStyles } from "@eisinc/Overrides/Widgets/AccountSettings/DefaultShippingAddress";
import { css } from "styled-components";

defaultShippingAddressStyles.headingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

defaultShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: center;
    `,
};
